import React from 'react';
import { Theme, ThemedText, ThemedView } from '@app/theme';
import { StyleSheet  } from 'react-native';
import { DefaultRTA } from '@app/types';
import Info from '../../../../assets/Icons/Info';
import { renderList } from '../utils';
import CreditCard from '../../../../assets/Icons/CreditCard';
import Phone from '../../../../assets/Icons/Phone';
import { useIsEnhanceLimit } from '@app/hooks/useIsEnhanceLimit';
import { useTheme } from '@shopify/restyle';

type BodyProps = {
    panNumber: string | null;
    mobileNumber: string;
    defaultRTA: DefaultRTA | undefined;
    onEditMobileNumber: () => void;
    onEditRTA: () => void;
};

const Body: React.FC<BodyProps> = ({
    panNumber,
    mobileNumber,
    onEditMobileNumber,
}) => {
    const {colors} = useTheme<Theme>()
    const { isFromEnhanceLimit : isFromEnhancedLimit } = useIsEnhanceLimit();
    const listData = [
        {
            title: 'PAN',
            subTitle: panNumber,
            icon: <CreditCard color={colors['icon-action-primary']} size={24} />,
            isEditable: false,
            handleEdit: () => {
                console.log('handleEdit');
            }
        },
        {
            title: 'Mobile number (linked to investments)',
            subTitle: mobileNumber,
            icon: <Phone color={colors['icon-action-primary']} size={24} bgColor={colors['bg-fill-emphasis-primary-1']} />,
            isEditable: true,
            handleEdit: onEditMobileNumber,
            isLast: true
        }
    ];

    return (
        <>
            <ThemedView style={ls.bodyContainer} backgroundColor='bg-fill-primary'>
                <ThemedText
                    variant='h3s'
                    style={{ marginBottom: 8 }}
                >
                    {
                        isFromEnhancedLimit ? 'Fetch updated portfolio' : 'Check eligible credit limit'
                    }
                </ThemedText>
                <ThemedText
                    variant='b3r'
                    color='text-secondary'
                    style={{ marginBottom: 32 }}
                >
                    Credit limit is calculated using your mutual fund portfolio.
                </ThemedText>
                {renderList(listData,colors['icon-action-primary'])}
                <ThemedView
                    flexDirection='row'
                    alignItems='center'
                    backgroundColor='bg-fill-info'
                    style={{
                        marginBottom: 16,
                        marginTop: 16,
                        paddingHorizontal: 16,
                        paddingVertical: 8
                    }}
                    borderRadius='sm'
                >
                    <Info size={24} />
                    <ThemedText variant='b4r' color='text-secondary' fontWeight='400' style={{ marginLeft: 8 }}>
                        Use mobile number linked to your investments.
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        </>
    );
};

export default Body; 

const ls = StyleSheet.create({
    bodyContainer: {
        paddingHorizontal: 16,
        paddingVertical: 24,
    }
});